/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { IIRecommendationResponse } from "@/contract/generated/electrify-v1";
import { findMedianValue } from "@/utils";

interface GetMedianSizeIndexProps {
  solarOutlook: IIRecommendationResponse;
}

export const getMedianSizeIndex = ({
  solarOutlook,
}: GetMedianSizeIndexProps) => {
  if (solarOutlook.systemData && solarOutlook.systemData.length) {
    const filteredSystemData = solarOutlook.systemData.filter(
      ({ size }) => size !== undefined
    );

    // If the number of filtered system data is an odd number, just get the middle index
    if (filteredSystemData.length % 2 !== 0) {
      return Math.ceil(filteredSystemData.length / 2) - 1;
    }

    const systemSizeList = filteredSystemData.map(({ size }) => size!);

    const medianValue = findMedianValue(systemSizeList);

    if (!medianValue) {
      return -1;
    }

    let medianIndex = 0;

    // The system size index that is defaulted is set to the median option or the lower side of median
    for (const systemSize of filteredSystemData) {
      const { size } = systemSize;
      if (size! > medianValue) {
        break;
      }

      medianIndex = solarOutlook.systemData.indexOf(systemSize);
    }

    return medianIndex;
  }

  return -1;
};
